import { LogIn, UserPlus, Users, ArrowLeft } from 'lucide-react';

export function LoginRequired({ recipe, sharedBy, inviteType = 'recipe', householdName, onSignIn, onSignUp, onBack }) {
  const isHouseholdInvite = inviteType === 'household';

  return (
    <div className="min-h-screen bg-[#F8F7F5] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        {/* Back Button - Only show if onBack is provided (for preview mode) */}
        {onBack && (
          <button
            onClick={onBack}
            className="mb-4 flex items-center gap-2 text-[#757575] hover:text-gray-900 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Back to Invitation</span>
          </button>
        )}

        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-white shadow-md flex items-center justify-center">
            <Users className="w-10 h-10 text-[#6B8A78]" />
          </div>
        </div>

        {/* Header */}
        <h1 className="text-2xl text-center mb-3" style={{ color: '#6B7A54' }}>
          {isHouseholdInvite
            ? (sharedBy ? `Join ${sharedBy}'s Household` : 'Join Household')
            : 'Sign in to open this recipe'}
        </h1>
        <p className="text-center text-[#757575] mb-8">
          {isHouseholdInvite
            ? 'Create an account or sign in to join this household and access shared meal plans and recipes'
            : 'Sign in or create an account to continue. Existing household members can open the recipe directly, and anyone outside the household will see the next steps instead.'}
        </p>

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={onSignUp}
            className="w-full py-4 bg-[#AFBB8B] text-white rounded-full hover:bg-[#9FAA7B] transition-colors flex items-center justify-center gap-2"
          >
            <UserPlus className="w-5 h-5" />
            <span>Create Account</span>
          </button>

          <button
            onClick={onSignIn}
            className="w-full py-4 bg-white text-gray-900 border-2 border-gray-200 rounded-full hover:bg-gray-50 transition-colors flex items-center justify-center gap-2"
          >
            <LogIn className="w-5 h-5" />
            <span>Sign In</span>
          </button>
        </div>

        {/* Privacy Note */}
        <p className="text-xs text-center text-[#757575] mt-6">
          Your privacy and data security are our top priorities.
        </p>
      </div>
    </div>
  );
}